export const notAllowSpecialCharacters = /^\S[a-zA-Z0-9 &-]*$/;
export const checkLowerCaseLetter = /[a-z]/;
export const checkUpperCaseLetter = /[A-Z]/;
export const checkSpecialCharacter = /[#?!@$%^&*-]/;
export const checkNumbers = /[0-9]/;
